import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useSocket } from '../contexts/SocketContext';
import { GeneralRoom, UserSupportPanel, AdminSupportInbox } from '../components/common/ChatCore';

const ADMIN_ROLES = ['super_admin', 'manager', 'assistant'];

export default function ChatPage() {
  const { user } = useAuth();
  const { socket, connected, onlineUsers } = useSocket();
  const [tab, setTab] = useState('general');
  const isAdmin = ADMIN_ROLES.includes(user?.role);

  return (
    <div style={{ paddingTop: 70, height: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <div style={{ background: 'var(--bg-secondary)', borderBottom: '1px solid var(--border)', padding: '14px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
        <div>
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 20, background: 'var(--gradient-primary)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>LIVE CHAT</h1>
          <p style={{ color: connected ? '#10b981' : '#ef4444', fontSize: 12, marginTop: 2 }}>
            {connected ? `🟢 Connected · ${onlineUsers.length} online` : '🔴 Connecting...'}
          </p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={() => setTab('general')} className={`btn btn-sm ${tab === 'general' ? 'btn-primary' : 'btn-secondary'}`}>🌐 General</button>
          <button onClick={() => setTab('support')} className={`btn btn-sm ${tab === 'support' ? 'btn-primary' : 'btn-secondary'}`}>
            {isAdmin ? '📬 Support Inbox' : '🎧 Live Support'}
          </button>
        </div>
      </div>

      {/* Body */}
      <div style={{ flex: 1, overflow: 'hidden', display: 'flex' }}>
        {tab === 'general'
          ? <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
              <GeneralRoom socket={socket} currentUser={user} compact={false} />
            </div>
          : isAdmin
            ? <AdminSupportInbox socket={socket} currentUser={user} />
            : <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <UserSupportPanel socket={socket} currentUser={user} compact={false} />
              </div>
        }
      </div>
    </div>
  );
}
